module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBold.28eef764.woff";